@let isActive = (entityId$ | async) === grid().id;

<div
    [id]="grid().id"
    class="grid-entity"
    [class.active]="isActive"
    [class.active-more-action]="isSettingsMenuOpened()"
    cdkDrag
    webSingleHover
    (hovered)="hovered($event)"
    [style.--grid-gap-x]="gridGapX()"
    [style.--grid-gap-y]="gridGapY()"
>
    <div cdkDragHandle style="display: none"></div>
    <div class="grid-root">
        @for (row of variantMap(); let rowIndex = $index; track rowIndex) {
            @for (cell of row; let cellIndex = $index; track cellIndex) {
                @let widgets = grid().children[cell.index];

                <div
                    class="grid-cell"
                    [style.--grid-column-cell]="cellGridColumns()[rowIndex][cellIndex]"
                    [id]="'grid_' + grid().id + '_' + cell.index"
                    cdkDropList
                    webNestedDropList
                    (cdkDropListDropped)="dropWidget($event)"
                    [cdkDropListConnectedTo]="connectedTo()"
                    [style.position]="'relative'"
                >
                    @for (widget of widgets; let i = $index; track widget.id) {
                        @if (widget) {
                            <web-grid-widget
                                [index]="i"
                                [widget]="widget"
                                [widgetErrors]="widgetErrorsById$(widget.id) | async"
                                [column]="column()"
                                [blockId]="blockId()"
                                [gridId]="grid().id"
                                [columnId]="grid().parentId"
                                [gridIndex]="cell.index"
                                [isMobile]="isMobile$ | async"
                                [isTablet]="isTablet$ | async"
                            />
                        }
                    } @empty {
                        <div class="widget-empty-state" (click)="addWidget(cell.index)">
                            <div>
                                <div class="add-icon">
                                    <span class="sp-icon icon-plus-add"> </span>
                                </div>
                            </div>
                        </div>
                    }

                    @if (cellsLength(row) !== cellIndex + 1) {
                        <web-grid-cell-resize
                            [leftWidth]="form.rowCellWidth().value()[rowIndex][cellIndex]"
                            [rightWidth]="form.rowCellWidth().value()[rowIndex][cellIndex + 1]"
                            [elementLeftId]="'grid_' + grid().id + '_' + cell.index"
                            [elementRightId]="'grid_' + grid().id + '_' + (cell.index + 1)"
                            (changeWidthToLeftEvent)="changeCellWidthToLeft(rowIndex, cellIndex, cellIndex + 1)"
                            (changeWidthToRightEvent)="changeCellWidthToRight(rowIndex, cellIndex, cellIndex + 1)"
                        />
                    }
                </div>
            }
        }
    </div>

    @if ((hideControls$ | async) && !hideControls()) {
        @if (hoverState()?.hover || isActive || isSettingsMenuOpened()) {
            <web-grid-controls
                class="grid-entity-controls"
                (toggleMoreActionState)="setSettingsMenuOpened($event)"
                (selectEvent)="selectGrid()"
                (deleteEvent)="deleteGrid()"
                (copyEvent)="copyGrid()"
                (addEvent)="addWidgetOrGrid()"
            />
        }
    }
</div>
